var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoDefaultItemTech(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "208px",
    height: "104px",
    viewBox: "0 0 208 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image copy 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 208,
    height: 104
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "36.240258%",
    x2: "0%",
    y2: "62.4722857%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FFFD",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FFFA",
    stopOpacity: 0.3,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "1.25854293%",
    x2: "0%",
    y2: "94.1808703%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FFFD",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FFFA",
    stopOpacity: 0.3,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.3472222%",
    y1: "0%",
    x2: "26.6527778%",
    y2: "95.3216553%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FFFD",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FFFA",
    stopOpacity: 0.3,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tests",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards/generic/default",
    transform: "translate(-16.000000, -72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-copy-17",
    transform: "translate(16.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "devices",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    stroke: "none",
    fill: "#F3F3F3",
    fillRule: "evenodd",
    points: "130.036068 70.3043478 167.470851 70.3043478 167.470851 78.2627165 163.897142 79.4347826 131.59997 79.4347826 130.036068 77.9044986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25346,21 C117.25346,21 117.406073,7.35872789 117.451288,7.36025247 C118.553665,7.39742271 115.241861,7.30434783 114.130435,7.30434783 C76.985655,7.30434783 45.0119605,27.7291649 28.7871731,58.4347826 C29.0227175,58.4531235 61.5578074,58.9353785 61.5578074,58.9353785 C61.5578074,58.9353785 61.5578074,36.1355347 61.5578074,26.312253 C61.5578074,25.0737254 62.7881984,22.3377758 64.7609969,21.4565217 C67.6360057,20.1722481 71.6012857,21 71.6012857,21 C57.8887339,21 117.25346,21 117.25346,21 Z",
    id: "Oval",
    stroke: "none",
    fill: "#6BC4D8",
    fillRule: "evenodd",
    opacity: 0.161202567
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.468656,70.3043478 C167.423552,70.2125085 167.409063,36.8409477 167.468656,36.7778727 C153.04924,43.466667 141.628269,55.526972 135.775064,70.3894655 C135.801397,70.3678775 167.409063,70.3043478 167.468656,70.3043478 Z",
    id: "Oval",
    stroke: "none",
    fill: "#6BC4D8",
    fillRule: "evenodd",
    opacity: 0.161202567
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.046132,31.5316615 C103.954689,34.8121074 82.902365,54.2837679 77.2684826,79.5673192 C77.4317043,79.5823497 106.365412,79.1755853 132.200938,79.3981607 C132.197815,79.3981338 130.036068,78.5542841 130.036068,74.8695652 C130.036068,65.4698382 130.137674,31.244544 130.046132,31.5316615 Z",
    id: "Oval",
    stroke: "none",
    fill: "#6BC4D8",
    fillRule: "evenodd",
    opacity: 0.161202567
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43503719,1.33749116 L9.8051864,0 L9.8051864,0 L113.391262,0 L115.561988,1.36284386 C115.657438,1.42276989 115.74207,1.49840002 115.812309,1.58653778 L117.25346,3.39493461 L117.25346,3.39493461 L117.25346,21.2255859 L66.758418,21.0243629 L63.8236851,21.7767787 C63.4973991,21.8604329 63.2351514,22.1027318 63.1259972,22.4213947 L61.5364965,27.0617569 L61.5364965,27.0617569 L61.4294107,58.4347826 L6.86215524,58.4347826 C6.30987049,58.4347826 5.86215524,57.9870674 5.86215524,57.4347826 L5.86215524,3.47874915 L5.86215524,3.47874915 L7.09771918,1.64881018 C7.18449814,1.5202857 7.29997955,1.41370509 7.43503719,1.33749116 Z",
    id: "Rectangle",
    stroke: "none",
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5578074,58.4347826 L5.86215524,58.4347826 C5.11376869,65.1304348 6.44291271,68.4782609 9.8495873,68.4782609 C13.2562619,68.4782609 10.1010309,68.4782609 0.383894367,68.4782609 C-0.872134845,75.7826087 0.953952112,79.5869565 5.86215524,79.8913043 C10.7703584,80.1956522 32.6834018,80.0434783 71.6012857,79.4347826 L71.6012857,21.4565217 L66.8700604,21 C63.3285584,21.0122669 61.5578074,22.7830178 61.5578074,26.312253 C61.5578074,29.8414881 61.5578074,40.548998 61.5578074,58.4347826 Z",
    id: "Path-15",
    stroke: "none",
    fill: "#F3F3F3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5578074,68.4782609 C61.5578074,68.4782609 41.1665031,68.4782609 0.383894367,68.4782609 C-0.872134845,75.7826087 0.953952112,79.5869565 5.86215524,79.8913043 C10.7703584,80.1956522 29.3355758,80.0434783 61.5578074,79.4347826 C63.5410189,79.5934175 64.5326246,79.5164018 64.5326246,79.2037354 C64.5326246,79.1795495 61.5578074,75.7339093 61.5578074,75.1260221 C61.5578074,70.6941813 61.5578074,68.4782609 61.5578074,68.4782609 Z",
    id: "Path-15",
    stroke: "none",
    fill: "#EDE9E9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1665031,68.4782609 C8.23699265,68.4782609 5.86215524,66.1198946 5.86215524,63.2107023 L5.86215524,5.26755853 C5.86215524,2.35836628 8.23699265,0 11.1665031,0 L111.949112,0 C114.878622,0 117.25346,2.35836628 117.25346,5.26755853 L117.25346,21.4007425",
    id: "Path",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6012857,21 L129.036068,21 C129.588353,21 130.036068,21.4477153 130.036068,22 L130.036068,77.1721244 L130.036068,77.1721244 L130.785676,78.9753176 L130.276569,79.2873698 C130.119304,79.3837641 129.938441,79.4347826 129.753984,79.4347826 L72.6012857,79.4347826 C72.0490009,79.4347826 71.6012857,78.9870674 71.6012857,78.4347826 L71.6012857,22 C71.6012857,21.4477153 72.0490009,21 72.6012857,21 Z",
    id: "Rectangle",
    stroke: "none",
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.775199,79.4347826 L6.68389437,79.4347826 C3.20450044,79.4347826 0.383894367,76.9820817 0.383894367,73.9565217 L0.383894367,68.4782609 L61.5578074,68.4782609",
    id: "Path",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.036068,15.5217391 L166.470851,15.5217391 C167.023136,15.5217391 167.470851,15.9694544 167.470851,16.5217391 L167.470851,69.3043478 C167.470851,69.8566326 167.023136,70.3043478 166.470851,70.3043478 L131.036068,70.3043478 C130.483784,70.3043478 130.036068,69.8566326 130.036068,69.3043478 L130.036068,16.5217391 C130.036068,15.9694544 130.483784,15.5217391 131.036068,15.5217391 Z",
    id: "Rectangle",
    stroke: "none",
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.86215524,
    y1: 58.4347826,
    x2: 61.5578074,
    y2: 58.4347826,
    id: "Path-2",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.3838944,
    y1: 50.673913,
    x2: 100.818677,
    y2: 50.673913,
    id: "Path-2",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(71.601286, 50.673913) rotate(-270.000000) translate(-71.601286, -50.673913) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.014329,79.1442688 C125.014329,82.0781451 122.635952,84.4565217 119.702076,84.4565217 L71.8917995,84.4565217 C68.9579232,84.4565217 66.5795465,82.0781451 66.5795465,79.1442688 L66.5795465,30.9851161 L66.5795465,15.9782609",
    id: "Path",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(95.796938, 50.217391) rotate(-270.000000) translate(-95.796938, -50.217391) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.036068,
    y1: 70.3043478,
    x2: 167.470851,
    y2: 70.3043478,
    id: "Path-2",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none",
    x: 130.036068,
    y: 15.5217391,
    width: 37.4347826,
    height: 63.9130435,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "none",
    fill: "#A5ADBD",
    fillRule: "evenodd",
    cx: 149.209981,
    cy: 74.8695652,
    r: 2.73913043
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDefaultItemTech);
export default __webpack_public_path__ + "static/media/PictoDefaultItemTech.d28f869991861981483128c029868178.svg";
export { ForwardRef as ReactComponent };